import type { DomainSchema, PdfCardDef } from '../types';
import { esc } from '../pdf-helpers';

export const HONORS = {
  priority: true,
  cardTitle: '{title}',
  fields: {
    title: { type: 'text' },
    issuer: { type: 'text' },
    date: { type: 'date' },
    description: { type: 'textarea' },
  },
  layout: [[{ field: 'issuer' }, { field: 'date' }], [{ field: 'description' }]],
  editLayout: [
    [{ field: 'title' }],
    [{ field: 'issuer' }, { field: 'date' }],
    [{ field: 'description' }],
  ],
} satisfies DomainSchema;

export const HonorsPdfCard: PdfCardDef = {
  styles: `
    .honor-item { display: flex; justify-content: space-between; align-items: baseline; gap: 0.75rem; padding: 5px 0; border-bottom: 1px solid var(--line); }
    .honor-item:first-child { padding-top: 0; }
    .honor-item:last-child { border-bottom: none; }
    .honor-title { font-size: 12px; color: var(--body); flex: 1; line-height: 1.4; }
    .honor-year  { font-size: 11px; color: var(--muted); white-space: nowrap; }
  `,
  render(records) {
    return records
      .map(r => {
        const yr = r['date'] ? String(r['date']).split('-')[0] : '';
        return `
          <div class="honor-item">
            <span class="honor-title">${esc(r['title'])}</span>
            ${yr ? `<span class="honor-year">${yr}</span>` : ''}
          </div>`;
      })
      .join('');
  },
};
